import * as React from 'react';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ReferenceDot } from 'recharts';
import { UserState } from '../../../interface/MyInterfaces';
import { VendorReportState, VendorReportAction, UserVendorReportState } from '../../../interface/VendorReportInterface';
import { NewVendorProfile } from '../../../interface/VendorReportInterface';
import Radar from 'react-d3-radar';
import Slider from 'rc-slider';
import renderHTML from 'react-render-html';
import "./ProfileTab.css";
import { billionNumberFormat, isAgg, numberWithCommas, percentageFormat, aggUniversityAlternateName } from '../../Common/Helpers';
import { exportVendorChart } from './NewVendorReportButtonHelpers'

export default class NewVendorTab1First extends React.Component<VendorReportState & UserState & VendorReportAction & UserVendorReportState, NewVendorProfile> {
    constructor(props) {
        super(props);
        let now: Date = new Date();
        var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();
        this.state = { currentDateTime: currentDate };
    }


    callSliderChange = (value) => {
        this.props.sliderChange(this.props.display_id, value, this.props.HomeState, this.props.VendorProfilesByYear);
    }




    render() {
        const vendorProfilesByYear = this.props.VendorProfilesByYear;
        const selectedYear = this.props.selected_year;
        const radarData = vendorProfilesByYear ? vendorProfilesByYear[parseInt(this.props.selected_year) - this.props.minYear] : null;
        const uniRadarPoints = {
            spending: {
                smallbus: radarData ? radarData.small_bus_pct : 0,
                women: radarData ? radarData.women_pct : 0,
                minority: radarData ? radarData.minority_pct : 0
            },
            count: {
                smallbus: radarData ? radarData.small_bus_estab_pct : 0,
                women: radarData ? radarData.women_estab_pct : 0,
                minority: radarData ? radarData.minority_estab_pct : 0
            }
        };
        const aggRadarPoints = {
            spending: {
                smallbus: radarData ? radarData.agg_small_bus_pct : 0,
                women: radarData ? radarData.agg_women_pct : 0,
                minority: radarData ? radarData.agg_minority_pct : 0
            },
            count: {
                smallbus: radarData ? radarData.agg_small_bus_estab_pct : 0,
                women: radarData ? radarData.agg_women_estab_pct : 0,
                minority: radarData ? radarData.agg_minority_estab_pct : 0
            }
        };
        const radarSpendingMax = Math.ceil(Math.max(uniRadarPoints.spending.minority, uniRadarPoints.spending.women, uniRadarPoints.spending.smallbus, aggRadarPoints.spending.minority, aggRadarPoints.spending.women, aggRadarPoints.spending.smallbus) / 10) * 10;
        const radarCountMax = Math.ceil(Math.max(uniRadarPoints.count.minority, uniRadarPoints.count.women, uniRadarPoints.count.smallbus, aggRadarPoints.count.minority, aggRadarPoints.count.women, aggRadarPoints.count.smallbus) / 10) * 10;

        // slider marks
        let markerValues = {};
        for (var i = 0; i < this.props.maxYear - this.props.minYear + 1; i++) {
            markerValues[this.props.minYear + i] = this.props.minYear + i;
        }

        return <div className='container-fluid boxshadow-div'>
            <div className='row'>
                <div className="col-md-12" >
                    <h3>About the Data</h3>
                    {this.renderAboutBullets()}
                </div>
                <div className="col-md-12" style={{ "marginTop": "40px", "marginBottom": "10px" }}>
                    <h3>Highlights</h3>
                    {this.renderBullets()}
                </div>
            </div>
            {this.props.minYear != this.props.maxYear &&
                <div className="row">
                    <div className="col-md-12">
                        <div className="slidecontainer">
                            <p>Current year: <strong>{this.props.selected_year}</strong></p>
                            <Slider onChange={this.callSliderChange} className="vendor-slider" dots={true} step={1} min={this.props.minYear} max={this.props.maxYear} defaultValue={this.props.maxYear} value={this.props.selected_year} marks={markerValues} />
                        </div>

                    </div>

                </div>
            }
            <div className='row'>
                <div className="line-chart col-md-6">
                    <p style={{ paddingTop: "5px" }}>
                        {(this.props.VendorReport_Tab1.section1_text) ?
                            renderHTML(this.props.VendorReport_Tab1.section1_text)
                            : <div>loading <i className="fa fa-spinner"></i></div>}
                    </p>
                    <a className="export" onClick={() => exportVendorChart("#chart1", "line-spending.png", this.props.display_id, this.state.currentDateTime, this.props.HomeState.campusname, this.props.selected_year ?? this.props.VendorReportState.TrendsPar[0].max_year, this.props.report_vintage_vendor)}><i className="fa fas fa-download new-vendor-report"></i>Export Chart</a>
                    <div id="chart1">
                        <div className="line-chart-legend-container">
                            <div>
                                <span className="color total"></span>
                                <span className="text">All Organizations</span>
                            </div>
                            <div>
                                <span className="color small"></span>
                                <span className="text">Small Business</span>
                            </div>
                            <div>
                                <span className="color minority"></span>
                                <span className="text">Woman-Owned Business</span>
                            </div>
                            <div>
                                <span className="color woman"></span>
                                <span className="text">Minority-Owned Business</span>
                            </div>

                        </div>
                        {selectedYear && vendorProfilesByYear && vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear)).length > 0 && 
                            <section className="LineTrend">
                                <h5>Spending</h5>
                                <LineChart width={500} height={150} data={vendorProfilesByYear} margin={{ bottom: 5, left: 5, right: 15, top: 50 }} syncId="spending">
                                    <YAxis tickFormatter={(value)=>billionNumberFormat(value)} interval={1} />
                                    <XAxis dataKey="start_year" hide={true} />
                                    <ReferenceDot x={selectedYear} y={vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear))[0].total_pmt} r={5} fill="#4682b4" />
                                    <ReferenceDot x={selectedYear} y={vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear))[0].small_business_pmt_amt} r={5} fill="#ff8882" />
                                    <Line dot={false} name="All Organizations" type="monotone" dataKey="total_pmt" stroke="#4682b4" />
                                    <Line dot={false} name="Small Business" type="monotone" dataKey="small_business_pmt_amt" stroke="#ff8882" />
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <Tooltip labelStyle={{ padding: 0 }} itemStyle={{ color: "#000" }} formatter={(value) => billionNumberFormat(value)} />
                                </LineChart>
                                <LineChart width={500} height={220} data={vendorProfilesByYear} margin={{ bottom: 5, left: 5, right: 15, top: 50 }} syncId="spending">
                                    <YAxis tickFormatter={(value) => billionNumberFormat(value)} interval={1} />
                                    <XAxis dataKey="start_year" />
                                    <ReferenceDot x={selectedYear} y={vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear))[0].women_pmt_amt} r={5} fill="#cfc793" />
                                    <ReferenceDot x={selectedYear} y={vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear))[0].minority_pmt_amt} r={5} fill="#008000" />
                                    <Line dot={false} name="Woman-Owned Business" type="monotone" dataKey="women_pmt_amt" stroke="#cfc793" />
                                    <Line dot={false} name="Minority-Owned Business" type="monotone" dataKey="minority_pmt_amt" stroke="#008000" />
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <Tooltip labelStyle={{ padding: 0 }} itemStyle={{ color: "#000" }} formatter={(value) => billionNumberFormat(value)} />
                                </LineChart>
                            </section>
                        }
                    </div>
                    <a className="export" onClick={() => exportVendorChart("#chart2", "line-establishment.png", this.props.display_id, this.state.currentDateTime, this.props.HomeState.campusname, this.props.selected_year ?? this.props.VendorReportState.TrendsPar[0].max_year, this.props.report_vintage_vendor)}><i className="fa fas fa-download new-vendor-report"></i>Export Chart</a>
                    <div id="chart2">
                        <div className="line-chart-legend-container">
                            <div>
                                <span className="color total"></span>
                                <span className="text">All Organizations</span>
                            </div>
                            <div>
                                <span className="color small"></span>
                                <span className="text">Small Business</span>
                            </div>
                            <div>
                                <span className="color minority"></span>
                                <span className="text">Woman-Owned Business</span>
                            </div>
                            <div>
                                <span className="color woman"></span>
                                <span className="text">Minority-Owned Business</span>
                            </div>

                        </div>

                        {selectedYear && vendorProfilesByYear && vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear)).length > 0 &&
                            <section className="LineTrend">
                                <h5>Establishment Count</h5>
                                <LineChart width={500} height={150} data={vendorProfilesByYear} margin={{ bottom: 5, left: 5, right: 15, top: 50 }} syncId="estab">
                                    <YAxis tickFormatter={(value) => numberWithCommas(value)} interval={1} />
                                    <XAxis dataKey="start_year" hide={true} />
                                    <ReferenceDot x={selectedYear} y={vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear))[0].total_estab} r={5} fill="#4682b4" />
                                    <ReferenceDot x={selectedYear} y={vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear))[0].small_business_estab_ct} r={5} fill="#ff8882" />
                                    <Line dot={false} name="All Organizations" type="monotone" dataKey="total_estab" stroke="#4682b4" />
                                    <Line dot={false} name="Small Business" type="monotone" dataKey="small_business_estab_ct" stroke="#ff8882" />
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <Tooltip labelStyle={{ padding: 0 }} itemStyle={{ color: "#000" }} formatter={(value) => numberWithCommas(value)} />
                                </LineChart>
                                <LineChart width={500} height={220} data={vendorProfilesByYear} margin={{ bottom: 5, left: 5, right: 15, top: 50 }} syncId="estab">
                                    <YAxis tickFormatter={(value) => numberWithCommas(value)} interval={1} />
                                    <XAxis dataKey="start_year" />
                                    <ReferenceDot x={selectedYear} y={vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear))[0].women_estab_ct} r={5} fill="#cfc793" />
                                    <ReferenceDot x={selectedYear} y={vendorProfilesByYear.filter(d => d.start_year === Number(selectedYear))[0].minority_estab_ct} r={5} fill="#008000" />
                                    <Line dot={false} name="Woman-Owned Business" type="monotone" dataKey="women_estab_ct" stroke="#cfc793" />
                                    <Line dot={false} name="Minority-Owned Business" type="monotone" dataKey="minority_estab_ct" stroke="#008000" />
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <Tooltip labelStyle={{ padding: 0 }} itemStyle={{ color: "#000" }} formatter={(value) => numberWithCommas(value)} />
                                </LineChart>
                            </section>
                        }
                </div>
                </div>

                <div className="radar-chart col-md-6">

                    <p style={{ paddingTop: "5px" }}>
                        {(this.props.VendorReport_Tab1.section2_text) ?
                            renderHTML(this.props.VendorReport_Tab1.section2_text)
                            : <span>loading <i className="fa fa-spinner"></i></span>}
                    </p>
                    <a className="export" onClick={() => exportVendorChart("#chart3", "radar-spending.png", this.props.display_id, this.state.currentDateTime, this.props.HomeState.campusname, this.props.selected_year ?? this.props.VendorReportState.TrendsPar[0].max_year, this.props.report_vintage_vendor)}><i className="fa fas fa-download new-vendor-report"></i>Export Chart</a>
                    <div id="chart3">
                        <div className="radar-legend">
                            <div className="radar-university">{aggUniversityAlternateName(this.props.university)}</div>
                            <div className="radar-agg">All Other IRIS Universities
                            {(radarData && radarData.agg_women_pct == 0) && <span style={{ display: 'block' }}>(unavailable for selected year)</span>}
                            </div>
                        </div>
                        <div className="radarStyle">
                            <h5>Spending</h5>
                            <Radar
                                width={380}
                                height={340}
                                padding={65}
                                domainMax={radarSpendingMax}
                                highlighted={null}
                                //onHover={this.showRadarToolTip}
                                data={{
                                    variables: [
                                        { key: 'smallbus', label: 'Small Business (%)' },
                                        { key: 'women', label: 'Woman-Owned Business (%)' },
                                        { key: 'minority', label: 'Minority-Owned Business (%)' }
                                    ],

                                    sets: [
                                        {
                                            key: 'umich',
                                            label: 'University of Michigan',
                                            values: uniRadarPoints.spending
                                        },
                                        {
                                            key: 'aggregated',
                                            label: 'University Aggregated',
                                            values: aggRadarPoints.spending
                                        }
                                    ],
                                }}
                            />
                        </div>
                    </div>
                    <div>
                        <a className="export" onClick={() => exportVendorChart("#chart4", "radar-establishment.png", this.props.display_id, this.state.currentDateTime, this.props.HomeState.campusname, this.props.selected_year ?? this.props.VendorReportState.TrendsPar[0].max_year, this.props.report_vintage_vendor)}><i className="fa fas fa-download new-vendor-report"></i>Export Chart</a>
                    </div>
                    <div id="chart4">
                        <div className="radar-legend">
                            <div className="radar-university">{aggUniversityAlternateName(this.props.university)}</div>
                            <div className="radar-agg">All Other IRIS Universities
                                {(radarData && radarData.agg_women_pct == 0) && <span style={{ display: 'block' }}>(unavailable for selected year)</span>}
                            </div>
                        </div>

                        <div className="radarStyle">
                            <h5>Establishment Count</h5>
                            <Radar
                                width={380}
                                height={340}
                                padding={65}
                                domainMax={radarCountMax}
                                highlighted={null}
                                //onHover={this.showRadarToolTip}
                                data={{
                                    variables: [
                                        { key: 'smallbus', label: 'Small Business (%)' },
                                        { key: 'women', label: 'Woman-Owned Business (%)' },
                                        { key: 'minority', label: 'Minority-Owned Business (%)' }
                                    ],

                                    sets: [
                                        {
                                            key: 'umich',
                                            label: 'University of Michigan',
                                            values: uniRadarPoints.count
                                        },
                                        {
                                            key: 'aggregated',
                                            label: 'University Aggregated',
                                            values: aggRadarPoints.count
                                        }
                                    ],
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }

    renderAboutBullets() {
        if (this.props.VendorReport_Tab1 && this.props.VendorReport_Tab1.aboutBullets && this.props.VendorReport_Tab1.aboutBullets != "") {
            //return (renderHTML(`<ul><li>${this.props.HomeState.campusname.charAt(0).toUpperCase() + this.props.HomeState.campusname.slice(1)} </li></ul>`))
            return (renderHTML(this.props.VendorReport_Tab1.aboutBullets))
        }
        return <div>loading <i className="fa fa-spinner"></i></div>
    }

    renderBullets() {
        if (this.props.BVDMatchRates && this.props.HomeState && this.props.VendorReport_Tab1 && this.props.VendorReport_Tab1.bullets && this.props.VendorReport_Tab1.bullets != "") {
            //return (renderHTML(`<ul><li>${this.props.HomeState.campusname.charAt(0).toUpperCase() + this.props.HomeState.campusname.slice(1)} </li></ul>`))
            return (renderHTML(this.props.VendorReport_Tab1.bullets))
        }
        return <div>loading <i className="fa fa-spinner"></i></div>

    }
}
